import { AttachmentResponse } from 'utils/api/inbox';

/**
 * Picks the right key to filter the attachment list after a delete.
 *
 * When the attachment is stored server-side (the parent has a noticeId,
 * the attachment has an id, and a deleteAttachment function is provided),
 * the API call removes it on the server and we filter the local list
 * by id.
 *
 * When any piece is missing (e.g. an unsaved attachment that hasn't
 * been uploaded yet, or a parent that doesn't wire a delete callback),
 * there's no server resource to delete; we just drop it from the local
 * list by its uri.
 */
export const filterAfterDelete = (
  attachments: AttachmentResponse[],
  pendingDelete: AttachmentResponse,
  hasServerResource: boolean,
): AttachmentResponse[] =>
  hasServerResource
    ? attachments.filter((a) => a.id !== pendingDelete.id)
    : attachments.filter((a) => a.uri !== pendingDelete.uri);

export const hasServerResource = (
  noticeId: number | undefined,
  attachmentId: number | undefined,
  deleteFn: ((noticeId: number, attachmentId: number) => Promise<void>) | undefined,
): boolean => !!noticeId && !!attachmentId && !!deleteFn;
